<template>
  <div class="infocontainer">
    <div class="title1">{{ $t("websit.privacy.title") }}</div>

    <div class="content">{{ $t("websit.privacy.item_0_content") }}</div>

    <div class="title2">{{ $t("websit.privacy.item_1_title") }}</div>
    <div class="content">{{ $t("websit.privacy.item_1_content") }}</div>

    <div class="title2">{{ $t("websit.privacy.item_2_title") }}</div>
    <div class="content">{{ $t("websit.privacy.item_2_content") }}</div>

    <div class="title2">{{ $t("websit.privacy.item_3_title") }}</div>
    <div class="content">{{ $t("websit.privacy.item_3_content") }}</div>

    <div class="title2">{{ $t("websit.privacy.item_4_title") }}</div>
    <div class="content">{{ $t("websit.privacy.item_4_content1") }}</div>
    <div class="content">{{ $t("websit.privacy.item_4_content2") }}</div>
    <div class="content">{{ $t("websit.privacy.item_4_content3") }}</div>
    <div class="content">{{ $t("websit.privacy.item_4_content4") }}</div>

    <div class="title2">{{ $t("websit.privacy.item_5_title") }}</div>
    <div class="content">{{ $t("websit.privacy.item_5_content") }}</div>

    <div class="title2">{{ $t("websit.privacy.item_6_title") }}</div>
    <div class="content">{{ $t("websit.privacy.item_6_content") }}</div>

    <div class="title2">{{ $t("websit.privacy.item_7_title") }}</div>
    <div class="content">{{ $t("websit.privacy.item_7_content") }}</div>

    <div class="title2">{{ $t("websit.privacy.item_8_title") }}</div>
    <div class="content">
      {{ $t("websit.privacy.item_8_content", { email: email }) }}
    </div>
  </div>
</template>

<script>
import { websitname, email, account } from "../../../common/project.config";
export default {
  data () {
    return {
      websitname, email, account
    }
  }
}
</script>

<style lang="scss" scoped>
.infocontainer {
  width: 1000px;
  padding: 70px 0;
  margin: 5px 0;
}
.title1,
.title2,
.title3 {
  color: $themeColor;
  font-weight: bold;
}
.content {
  color: #fff;
  font-size: 14px;
}
.title1 {
  margin-bottom: 28px;
  font-size: 20px;
}
.title2 {
  font-size: 18px;
  line-height: 30px;
}
.title3 {
  font-size: 14px;
  line-height: 26px;
}
</style>